<template>
  <div class="classifiers__base base">
    <div class="base__title" @click="toggleBase">
      <div
        class="base__icon"
        :style="dbIconStyle"
        :title="classifier.name"
      ></div>

      <span>
        {{ classifier.name }}
      </span>
    </div>

    <ul v-if="baseOpened && classifier.folders" class="base__list">
      <search-classifiers-item
        v-for="item in classifier.folders"
        :key="item.id"
        :item="item"
      />
    </ul>
  </div>
</template>

<script>
import SearchClassifiersItem from './SearchClassifiersItem';

export default {
  components: {
    SearchClassifiersItem
  },

  props: {
    classifier: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    baseOpened: false
  }),

  computed: {
    database() {
      return this.$store.state.databases[this.classifier.dbId];
    },
    dbIconStyle() {
      return this.database
        ? {
            backgroundImage: `url('${this.database.iconUrl}')`
          }
        : '';
    }
  },

  methods: {
    async toggleBase() {
      if (!this.classifier.folders) {
        await this.$store.dispatch('getClassifierFolders', this.classifier.id);
      }
      this.baseOpened = !this.baseOpened;
    }
  }
};
</script>
